import type { HeadingPiece } from './noteText.types';

// A short line ending in its only colon, e.g. "Ástæða komu:".
const HEADING_LINE = /^[^:\n]{1,60}:$/;

const headingRanges = (text: string): [number, number][] => {
  const ranges: [number, number][] = [];
  let position = 0;
  for (const line of text.split('\n')) {
    if (HEADING_LINE.test(line.trim())) ranges.push([position, position + line.length]);
    position += line.length + 1;
  }
  return ranges;
};

const cutPiece = (text: string, start: number, ranges: [number, number][]): HeadingPiece[] => {
  const end = start + text.length;
  const pieces: HeadingPiece[] = [];
  let cursor = start;
  for (const [rangeStart, rangeEnd] of ranges) {
    if (rangeEnd <= cursor || rangeStart >= end) continue;
    const from = Math.max(rangeStart, cursor);
    const to = Math.min(rangeEnd, end);
    if (from > cursor) pieces.push({ text: text.slice(cursor - start, from - start), heading: false });
    pieces.push({ text: text.slice(from - start, to - start), heading: true });
    cursor = to;
  }
  if (cursor < end) pieces.push({ text: text.slice(cursor - start), heading: false });
  return pieces;
};

/**
 * Splits rendered note text into heading and body pieces, so section lines can be styled.
 * Takes the pieces a view renders in order (diff segments, attributed parts); headings are
 * found on their joined text, so a heading split across pieces is still marked. Text is unchanged.
 */
export const splitHeadings = (texts: string[]): HeadingPiece[][] => {
  const ranges = headingRanges(texts.join(''));
  let offset = 0;
  return texts.map((text) => {
    const start = offset;
    offset += text.length;
    return cutPiece(text, start, ranges);
  });
};
